import { namespaceActions } from 'modules/app-core/redux-utils'
import { NAME } from './constants'

const LOAD_MESSAGE_LIST = 'LOAD_MESSAGE_LIST'
const LOAD_MESSAGE = 'LOAD_MESSAGE'
const TOGGLE_VIEW = 'TOGGLE_VIEW'

export default namespaceActions(NAME)([
  LOAD_MESSAGE_LIST,
  LOAD_MESSAGE,
  TOGGLE_VIEW,
])
